<template>
  <div class="search-cont per-cert">
    <div class="zhezhao"></div>
    <div class="publish">
      <div class="comeBack" @click="back">返回</div>
      <ul class="account-data">
        <li>
          <label>帐号名称</label>
          <input type="text" v-model="accountName" placeholder="请输入" />
          <p class="note">
            2-10个字，请勿使用含特殊符号或含有明显营销推广意图的媒体名。
            <!-- <span>《头条号名称注册规范》</span> -->
          </p>
        </li>
        <li>
          <label>帐号介绍</label>
          <textarea v-model="accountIntroduce"></textarea>
          <p class="note">10-30个字，要求内容完整通顺，无特殊符号请勿添加任何联系方式如微博、手机号。</p>
        </li>
        <li class="icon">
          <label>帐号头像</label>
          <div class="icon-img">
            <img :src="accountPic" alt />
          </div>
          <div class="upload-note">
            <label class="upload-btn" for="input">上传图片</label>
            <input type="file" id="input" @change="getFile($event)" hidden />
            <p class="require">要求清晰、健康、代表品牌形象</p>
            <p>请勿使用二维码，最大5M,200x200像素</p>
          </div>
        </li>
        <li v-if="type != 1">
          <label>组织名称</label>
          <input type="text" placeholder="请输入" v-model="teamName" />
          <p class="note">请与组织机构代码证或营业执照名称一致</p>
        </li>
        <li v-if="type != 1" class="icon">
          <label>组织机构代码证/营业执照</label>
          <div class="icon-img">
            <img :src="businessLicense" alt />
          </div>
          <div class="upload-note">
            <label class="upload-btn" for="zhizhao">上传图片</label>
            <input type="file" id="zhizhao" @change="getFiles($event)" hidden />
            <p class="require">组织机构代码证或营业执照信息清晰</p>
            <p>最大2M</p>
          </div>
        </li>
        <li v-if="type != 1" class="icon">
          <label>确认书扫描件</label>
          <div class="icon-img">
            <img :src="scanningCopy" alt />
          </div>
          <div class="upload-note">
            <label class="upload-btn" for="scann">上传图片</label>
            <input type="file" id="scann" @change="getscann($event)" hidden />
            <p class="exam" style="cursor:pointer" @click="getWord">
              请
              <span>点此下载确认书模板,</span> 填写后上传
            </p>
          </div>
        </li>
        <li v-if="type != 1" class="network">
          <label>网站</label>
          <input type="text" v-model="website" placeholder="请输入" />
        </li>
        <li v-if="type != 1">
          <label>所在地</label>
          <div class="block">
            <el-cascader
              v-model="value"
              :options="options"
              :props="{ expandTrigger: 'hover' }"
              @change="handleChange"
            ></el-cascader>
          </div>
        </li>
        <li>
          <label>运营者姓名</label>
          <input type="text" placeholder="请输入" v-model="operatorName" />
          <p class="note">请务必与上传的身份证件保持一致</p>
        </li>
        <li>
          <label>运营者身份证号</label>
          <input type="text" placeholder="请输入" v-model="operatorIdNumber" />
          <p class="note">请务必与上传的身份证件保持一致</p>
        </li>
        <li class="icon">
          <label>运营者身份证照片</label>
          <div class="icon-img">
            <img :src="operatorIdPic" alt />
          </div>
          <div class="upload-note">
            <label class="upload-btn" for="Idcard">上传图片</label>
            <input type="file" id="Idcard" @change="getsIdcard($event)" hidden />
            <p class="exam">
              请
              <span>参照事例</span>手持身份证件拍摄
            </p>
            <p class="require">要求清晰、健康、代表品牌形象</p>
            <p>请勿使用二维码，最大5M,200x200像素</p>
          </div>
        </li>
        <li>
          <label>联系电话</label>
          <input type="text" v-model="bindPhone" placeholder="请输入" />
        </li>
        <li>
          <label>联系邮箱</label>
          <input type="text" v-model="email" placeholder="请输入" />
        </li>
      </ul>
      <!-- <p class="agree">
        <i :class="['iconfont', isActive?'active':'']" @click="agreement"></i>请同意
        <span>《头条号用户注册协议》</span>
      </p>-->
      <div class="save-btn">
        <div class="btn-list" @click="back" style="float:left;">上一步</div>
        <el-button class="btn-list fr" @click="submitData" style="float:right;margin:0px;">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import axios from "axios";
import Vue from "vue";
import city from "../../assets/comment/city.data-3.js";
export default {
  data() {
    return {
      value: [],
      vals: [],
      opt: [],
      options: Object.freeze(city),
      isActive: false,
      value: "",
      accountName: "",
      accountIntroduce: "",
      accountPic: "http://img.jzda001.com/image/9931563267877442.png",
      teamName: "",
      businessLicense: require("../../assets/img/bg.png"),
      scanningCopy: require("../../assets/img/bg.png"),
      website: "",
      address: "",
      operatorName: "",
      operatorIdNumber: "",
      operatorIdPic: require("../../assets/img/card.png"),
      bindPhone: "",
      email: ""
    };
  },
  computed: {
    type() {
      return this.$store.state.mediaType;
    }
  },
  mounted() {},
  methods: {
    getCascaderObj(val, opt) {
      return val.map(function(value, index, array) {
        for (var itm of opt) {
          if (itm.value == value) {
            opt = itm.children;
            return itm;
          }
        }
        return null;
      });
    },
    handleChange() {
      this.vals = this.getCascaderObj(this.value, this.options);
      var lab = [];
      $.each(this.vals, function(k, v) {
        lab.push(v.label);
      });
      this.address = lab.join(",");
    },
    back() {
      this.$parent.name = "authentic";
      document.documentElement.scrollTop = 0;
    },
    agreement() {
      this.isActive = !this.isActive;
    },
    // 导出word文档
    getWord() {
      window.open("http://jianzhu.zjxtaq.com/app/model.docx", "_blank");
    },
    // 上传图片
    getFile(e) {
      let param = new FormData();
      param.append("file", e.target.files[0]);
      axios({
        method: "post",
        url: "https://admin.jzda001.com/tools/uploadFileForJson",
        data: param,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res, "上传头像");
        if (res.status == 200) {
          this.accountPic = res.data.url;
        }
      });
    },
    getFiles(e) {
      let param = new FormData();
      param.append("file", e.target.files[0]);
      axios({
        method: "post",
        url: "https://admin.jzda001.com/tools/uploadFileForJson",
        data: param,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res, "上传头像");
        if (res.status == 200) {
          this.businessLicense = res.data.url;
        }
      });
    },
    getscann(e) {
      let param = new FormData();
      param.append("file", e.target.files[0]);
      axios({
        method: "post",
        url: "https://admin.jzda001.com/tools/uploadFileForJson",
        data: param,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res, "上传头像");
        if (res.status == 200) {
          this.scanningCopy = res.data.url;
        }
      });
    },
    getsIdcard(e) {
      let param = new FormData();
      param.append("file", e.target.files[0]);
      axios({
        method: "post",
        url: "https://admin.jzda001.com/tools/uploadFileForJson",
        data: param,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res, "上传头像");
        if (res.status == 200) {
          this.operatorIdPic = res.data.url;
        }
      });
    },
    submitData() {
      var mreg = /^((0\d{2,3}\d{7,8})|(1[34578]\d{9}))$/;
      //媒体认证
      if (this.accountName == "") {
        this.$message("请输入账号名称");
        return false;
      }
      if (this.accountIntroduce == "") {
        this.$message("请输入账号介绍");
        return false;
      }
      if (this.teamName == "" && this.type != 1) {
        this.$message("请输入组织名称");
        return false;
      }
      if (this.businessLicense.indexOf("data:") == 0 && this.type == 1) {
        this.businessLicense = "";
      }
      if (this.businessLicense.indexOf("data:") == 0 && this.type != 1) {
        this.$message("请上传组织机构代码证/营业执照");
        return false;
      }
      if (this.scanningCopy.indexOf("data:") == 0 && this.type == 1) {
        this.scanningCopy = "";
      }
      if (this.scanningCopy.indexOf("data:") == 0 && this.type != 1) {
        this.$message("请上传确认书扫描件");
        return false;
      }
      if (this.address == "" && this.type != 1) {
        this.$message("请输入地址");
        return false;
      }
      if (this.operatorName == "") {
        this.$message("请输入运营者姓名");
        return false;
      }
      if (this.operatorIdNumber == "") {
        this.$message("请输入运营者身份证号");
        return false;
      }
      if (this.operatorIdPic == require("../../assets/img/card.png")) {
        this.$message("请输入运营者身份证照片");
        return false;
      }
      if (this.bindPhone == "") {
        this.$message("请输入联系电话");
        return false;
      }
      if (!mreg.test(this.bindPhone)) {
        this.$message("请输入正确的手机号或座机号");
        return false;
      }
      if (this.email == "") {
        this.$message("请输入邮箱");
        return false;
      }

      this.$http
        .get("/api/media/001-mediaCertificationSave", {
          params: {
            type: this.type,
            accountName: this.accountName,
            accountIntroduce: this.accountIntroduce,
            accountPic: this.accountPic,
            teamName: this.teamName,
            businessLicense: this.businessLicense,
            scanningCopy: this.scanningCopy,
            website: this.website,
            address: this.address,
            operatorName: this.operatorName,
            operatorIdNumber: this.operatorIdNumber,
            operatorIdPic: this.operatorIdPic,
            bindPhone: this.bindPhone,
            email: this.email,
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          console.log(res, "提交认证");
          if (res.data.code == 0) {
            this.$message("提交成功");
            console.log(res.data.rows[0].status);
            document.documentElement.scrollTop = 0;
            this.$store.commit("userPerson", { a: true });
            let user = {
              id: this.$store.state.userInfo.id,
              phone: this.$store.state.userInfo.phone,
              token: this.$store.state.userInfo.token,
              role: 1,
              status: res.data.rows[0].status,
              remark: res.data.rows[0].remark
            };
            this.$store.commit("setUserInfo", user);
            this.$emit("childUserInfo", {
              id: this.$store.state.userInfo.id,
              phone: this.$store.state.userInfo.phone,
              token: this.$store.state.userInfo.token,
              role: 1,
              status: 1,
              remark: "",
              type: "mediaOrg"
            });
          } else {
            this.$message(res.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
input {
  cursor: pointer;
}
.comeBack {
  width: 90px;
  height: 40px;
  line-height: 40px;
  border-radius: 3px;
  border: 1px solid #2e8043;
  color: #2e8043;
  font-size: 16px;
  position: absolute;
  top: 20px;
  left: 50px;
  cursor: pointer;
}
.search-cont .center .cont-right .close {
  width: 20px;
  height: 20px;
}

.close:hover,
.close {
  opacity: 1;
}
.zhezhao {
  background: rgba(255, 255, 255, 1);
}
.per-cert .account-data li.network label {
  padding-left: 15px;
}
.per-cert .account-data li.network label::before {
  display: none;
}
.per-cert .account-data li .upload-note .upload-btn {
  padding-top: 0px;
  text-align: center;
}
.per-cert .account-data li .upload-note .upload-btn::before {
  display: none;
}
.per-cert .account-data li input {
  margin-left: 0px;
}
.publish .btn-list:hover {
  border-color: #2e8043;
  color: #2e8043;
}
/deep/.el-input__inner {
  border: 1px solid #eee !important;
}
/deep/.el-input__inner::-webkit-input-placeholder {
  color: #666;
}
</style>
<style>
.el-select > .el-input {
  overflow: hidden;
}
.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #2e8043 !important;
}
.el-cascader .el-input .el-input__inner:focus,
.el-cascader .el-input.is-focus .el-input__inner {
  border-color: #2e8043 !important;
}
.el-input--suffix .el-input__inner {
  width: 300px !important;
}
.el-popper {
  width: 300px !important;
}
.el-cascader .el-input .el-input__inner:focus {
  border-color: #eee !important;
}
.el-cascader .el-input.is-focus .el-input__inner {
  border-color: #eee !important;
}
.el-cascader .el-input .el-input__inner {
  margin-left: 0px;
}
.el-select .el-input__inner:focus {
  border-color: #eee !important;
}
.el-cascader {
  float: left;
}
.el-popper {
  width: 540px !important;
}
</style>
